import { SpinningLoader } from "risa-oasis-ui_v2";
import { CommonLiterals } from "../../../../enums/StringLiterals/commonLiterals";

interface AuthTabProps {
  filePath: string;
  loading: boolean;
  error: string | null;
  formattedTime: string;
}
const AuthTab = ({ filePath, loading, error, formattedTime }: AuthTabProps) => {
  return (
    <div className="flex h-full w-full border-1 border-primaryGray-15 bg-[#F7F9FA]">
      <div className="flex h-full flex-1 flex-col overflow-hidden rounded-md border border-primaryGray-15 bg-white">
        <div className="flex flex-row justify-between border-b border-primaryGray-15 bg-primaryGray-16 px-4 py-2 text-small font-semibold leading-6 text-primaryGray-1 shadow-md">
          Auth/Referal
          <div>
            {formattedTime || ""}
            <span className="ml-1">{`(IST)`}</span>
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-2 overflow-auto px-4 py-2">
          {loading && (
            <div className="flex h-full w-full flex-col items-center justify-center gap-2">
              <SpinningLoader />
              <div className="text-sm text-primaryGray-6">
                {CommonLiterals.LOADING}
              </div>
            </div>
          )}
          {filePath && !loading && (
            <img
              src={filePath}
              alt="Text Note Screenshot"
              className="max-h-full max-w-full object-contain"
            />
          )}
        </div>
        {error && (
          <div className="flex h-full w-full flex-col items-center justify-center gap-2">
            <div className="text-sm text-primaryGray-6">
              {CommonLiterals.NO_SCREENSHOT_AVAILABLE}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthTab;
